import React, { useState } from 'react';
import { Modal, Form, Input, Button, Alert, Space, InputNumber } from 'antd';
import { PlusOutlined, CloseOutlined, SaveOutlined } from '@ant-design/icons';
import { createDomainData } from '../api/domainDataApi';

const { TextArea } = Input;

function DomainDataCreateModal({ isOpen, onClose, onSuccess }) {
  const [form] = Form.useForm();
  const [createLoading, setCreateLoading] = useState(false);
  const [createError, setCreateError] = useState(null);

  const handleSubmit = async (values) => {
    setCreateError(null);
    setCreateLoading(true);
    try {
      await createDomainData(values);
      form.resetFields();
      if (onSuccess) onSuccess();
      onClose();
    } catch (err) {
      setCreateError('등록에 실패했습니다: ' + (err?.response?.data?.message || err.message));
    } finally {
      setCreateLoading(false);
    }
  };

  const handleClose = () => {
    form.resetFields();
    setCreateError(null);
    onClose();
  };

  return (
    <Modal
      title={
        <Space>
          <PlusOutlined />
          <span>도메인 신규생성</span>
        </Space>
      }
      open={isOpen}
      onCancel={handleClose}
      width={800}
      footer={null}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px' }}>
          <Form.Item label="도메인그룹명" name="domainGroupNm" rules={[{ required: true, message: '도메인그룹명을 입력해주세요' }]}>
            <Input placeholder="도메인그룹명을 입력하세요" />
          </Form.Item>
          <Form.Item label="도메인분류명" name="domainClsfNm" rules={[{ required: true, message: '도메인분류명을 입력해주세요' }]}>
            <Input placeholder="도메인분류명을 입력하세요" />
          </Form.Item>
          <Form.Item label="도메인명" name="domainNm" rules={[{ required: true, message: '도메인명을 입력해주세요' }]}>
            <Input placeholder="도메인명을 입력하세요" />
          </Form.Item>
          <Form.Item label="데이터유형" name="dataType" rules={[{ required: true, message: '데이터유형을 입력해주세요' }]}>
            <Input placeholder="데이터유형을 입력하세요" />
          </Form.Item>
          <Form.Item label="데이터길이" name="dataLen">
            <InputNumber style={{ width: '100%' }} placeholder="데이터길이를 입력하세요" />
          </Form.Item>
          <Form.Item label="소수점길이" name="dcptLen">
            <InputNumber style={{ width: '100%' }} placeholder="소수점길이를 입력하세요" />
          </Form.Item>
          <Form.Item label="저장형식" name="strgFrm">
            <Input placeholder="저장형식을 입력하세요" />
          </Form.Item>
          <Form.Item label="표시형식" name="indctFrm">
            <Input placeholder="표시형식을 입력하세요" />
          </Form.Item>
          <Form.Item label="단위" name="unit">
            <Input placeholder="단위를 입력하세요" />
          </Form.Item>
          <Form.Item label="허용값" name="prmVl">
            <Input placeholder="허용값을 입력하세요" />
          </Form.Item>
          <Form.Item label="도메인설명" name="domainExpln" rules={[{ required: true, message: '도메인설명을 입력해주세요' }]} style={{ gridColumn: '1 / span 3' }}>
            <TextArea rows={2} placeholder="설명을 입력하세요" />
          </Form.Item>
        </div>

        {createError && (
          <Alert
            message="오류"
            description={createError}
            type="error"
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}

        <div style={{ textAlign: 'right', marginTop: 16 }}>
          <Button icon={<CloseOutlined />} onClick={handleClose} style={{ marginRight: 8 }}>
            취소
          </Button>
          <Button type="primary" htmlType="submit" icon={<SaveOutlined />} loading={createLoading}>
            저장
          </Button>
        </div>
      </Form>
    </Modal>
  );
}

export default DomainDataCreateModal;

